module.exports = __webpack_public_path__ + "img/republic-of-the-congo.e6f61257.svg";